import { createComponent } from '../core/create-component.js';
var MainContentStart = createComponent({
  displayName: 'MainContentStart',
  root: 'span'
});
MainContentStart.defaultProps = {
  id: 'maincontentstart'
};
export { MainContentStart };